/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormControl, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { AddressDTO } from "@well/address-management-domain-model";
import { FormUtils } from "@irian-ro/util-forms";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { CommonModule } from "@angular/common";
import { AddressPickerComponent } from "../address-picker/address-picker.component";
import { ButtonModule } from "primeng/button";

@Component({
  selector: 'well-submitable-address-picker',
  templateUrl: './submitable-address-picker.component.html',
  styleUrls: ['./submitable-address-picker.component.scss'],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, AddressPickerComponent, ButtonModule, TranslateModule],
})
export class SubmitableAddressPickerComponent {
  @Input() validateForDistance = true;

  @Input() displayTypeField = false;

  @Input() displayVisibilityField = false;

  @Input() searchLocal = true;

  @Input() searchOnGoolge = true;

  @Input() meta: any = null;

  @Input() displayAddressTemplateSave = false;

  @Input() disableFieldsUntilInput = true;

  @Input() hideFieldsUntilInput = false;

  @Input() mapFloatRight = false;

  @Input() mapHeight = 0;

  @Input() displayAsString = false;

  @Input() editString = true;

  @Input() handoverAddress = false;

  @Input() showAddressLabel = true;

  @Input()
  set address(value: AddressDTO) {
    this.form.patchValue({ addressDTO: value });
  }

  @Output() addressSubmit: EventEmitter<AddressDTO> = new EventEmitter<AddressDTO>();

  form = new FormGroup({
    addressDTO: new FormControl<AddressDTO | null>(null),
  });

  constructor(private translateService: TranslateService) {}

  onSubmit() {
    FormUtils.markAllAsDirty(this.form);
    FormUtils.markAllAsTouched(this.form);
    if (this.form.valid) {
      const address: AddressDTO | null = this.form.getRawValue().addressDTO;
      if(address) {
        this.addressSubmit.next(address);
      }
    }
  }
}
